import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'multi-dashboard-v2',
  templateUrl: './multi-dashboard-v2.component.html',
  styleUrls: ['./multi-dashboard-v2.component.scss'],
  standalone: false,
})
export class MultiDashboardV2Component implements OnInit {
  dashboardType = '';
  boards: string[] = [];
  fetchingKpis = 0;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.dashboardType = params['dashboardType'];
      this.boards = [];
    });
  }

  isFetchingKpis(isFetching: any) {
    console.log(isFetching);
    if (isFetching) this.fetchingKpis++;
    else this.fetchingKpis--;
  }
}
